import { t } from "i18next";
import { filter } from "lodash";

let store;
export const injectConstStore = (_store) => {
  store = _store;
};

export const ERROR_MSG = "It looks like I’m unable to retrieve that information right now. Please try again later.";

export const DEFAULT_SESSION_ID = "fake_hyly_session_id";

export const INITIAL_MSGS = [{ message: "welcomeMessage", speaker: "bot", createdAt: new Date(), isInitMessage: true }];

export const ESSENTIAL_VALUES = ["property_id", "api_key", "appSSID"];

export const INITIAL_REPLY_OPTIONS = [
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: "search", label: "findHome", callbackOptions: null, type: "exploreContact" },
    },
    nextOptionsType: "BedroomTypes",
    message: [{ message: "findHome", speaker: "user" }],
    key: "find_home",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: "clock", label: "scheduleTour", callbackOptions: null, type: "exploreContact" },
    },
    nextOptionsType: "Form4ScheduleTour",
    message: [{ message: "scheduleTour", speaker: "user" }],
    key: "schedule_tour",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: "", label: "photos", callbackOptions: null, type: "learnMore" },
    },
    nextOptionsType: "Photos",
    message: [{ message: "photos", speaker: "user" }],
    key: "photos",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: "", label: "videos", callbackOptions: null, type: "learnMore" },
    },
    nextOptionsType: "Videos",
    message: [{ message: "videos", speaker: "user" }],
    key: "videos",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: "", label: "communityInfo", callbackOptions: null, type: "learnMore" },
    },
    nextOptionsType: "CommunityInfo",
    message: [{ message: "communityInfo", speaker: "user", type: "learnMore" }],
    key: "community_info",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: "send", label: "contactMe", callbackOptions: null, type: "exploreContact" },
    },
    nextOptionsType: "Form4ContactUs",
    message: [{ message: "contactMe", speaker: "user" }],
    key: "contact_us",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: "", label: "residentalPortal", callbackOptions: null, type: "quickActions" },
    },
    nextOptionsType: "VisitResidentPortal",
    message: [{ message: "residentalPortal", speaker: "user" }],
    key: "visit_resident_portal",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
  // {
  //   content: {
  //     component: "NormalOptionTile",
  //     componentOptions: { icon: "", label: "Ask Me Anything", callbackOptions: null, type: "quickActions" },
  //   },
  //   nextOptionsType: "FAQs",
  //   message: [{ message: "Ask Me Anything", speaker: "user" }],
  //   key: "faqs",
  //   event: "h_click",
  //   disablePlaceholerMessage: false,
  //   data: null,
  // },
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: "", label: "doIQualify", callbackOptions: null, type: "quickActions" },
    },
    nextOptionsType: "DoIQualify",
    message: [{ message: "doIQualify", speaker: "user" }],
    key: "do_i_qualify",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
];

export const CANCEL_TOUR_OPTIONS = [
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: "", label: "yesCancel", callbackOptions: null, type: "" },
    },
    nextOptionsType: "cancelTour",
    message: [{ message: "yesCancel", speaker: "user" }],
    key: "cancel_tour",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: "", label: "dontCancel", callbackOptions: null, type: "" },
    },
    nextOptionsType: "noDoNotCancel",
    message: [{ message: "dontCancel", speaker: "user" }],
    key: "no_donot_cancel",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
];

export const LANG_CHANGE_OPTIONS = [
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: "", label: "Yes", callbackOptions: null, type: "" },
    },
    nextOptionsType: "yesLangChange",
    message: [{ message: "Yes", speaker: "user" }],
    key: "yes_lang_change",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: "", label: "No", callbackOptions: null, type: "" },
    },
    nextOptionsType: "noLangChange",
    message: [{ message: "No", speaker: "user" }],
    key: "no_lang_change",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
];

export const RESCHEDULE_TOUR_OPTIONS = [
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: "", label: "rescheduleTour", callbackOptions: null, type: "" },
    },
    nextOptionsType: "rescheduleFromTourStatus",
    message: [{ message: "rescheduleTour", speaker: "user" }],
    key: "rescheduleFromTourStatus",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: "", label: "cancelTour", callbackOptions: null, type: "" },
    },
    nextOptionsType: "cancelTourFromTourStatus",
    message: [{ message: "cancelTour", speaker: "user" }],
    key: "cancelTourFromTourStatus",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
];

export const CUSTOM_BUTTON = {
  content: {
    component: "LinkOptionTile",
    componentOptions: {
      icon: "OpenLinkIcon",
      label: "Apply Now",
      link: "https://www.propertysite.com/applynow",
      id: "",
      type: "quickActions",
    },
  },
  message: [],
  nextOptionsType: null,
  key: "custom_btn",
  event: "h_click",
  disablePlaceholerMessage: false,
  data: null,
};

const FEEDBACK_TOUR_OPTIONS = [
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: "like", label: "excellent", callbackOptions: null },
    },
    nextOptionsType: "LikeTour",
    message: [{ message: "excellent", speaker: "user" }],
    key: "thumbs_up",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: "thumbs_up",
  },
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: "dislike", label: "needImprovement", callbackOptions: null },
    },
    nextOptionsType: "DisLikeTour",
    message: [{ message: "needImprovement", speaker: "user" }],
    key: "thumbs_down",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: "thumbs_down",
  },
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: "", label: "skip", callbackOptions: null },
    },
    nextOptionsType: "SkipTour",
    message: [{ message: "skip", speaker: "user" }],
    key: "skip",
    event: "h_click",
    disablePlaceholerMessage: true,
    data: "skip",
  },
];

const FEEDBACK_CONTACT_OPTIONS = [
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: "like", label: "excellent", callbackOptions: null },
    },
    nextOptionsType: "LikeContact",
    message: [{ message: "excellent", speaker: "user" }],
    key: "thumbs_up",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: "thumbs_up",
  },
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: "dislike", label: "needImprovement", callbackOptions: null },
    },
    nextOptionsType: "DisLikeContact",
    message: [{ message: "needImprovement", speaker: "user" }],
    key: "thumbs_down",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: "thumbs_down",
  },
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: "", label: "skip", callbackOptions: null },
    },
    nextOptionsType: "SkipContact",
    message: [{ message: "skip", speaker: "user" }],
    key: "skip",
    event: "h_click",
    disablePlaceholerMessage: true,
    data: "skip",
  },
];

export const RETRY_OPTION = {
  content: {
    component: "NormalOptionTile",
    componentOptions: { icon: "", label: "retry", callbackOptions: null },
  },
  nextOptionsType: "Init",
  message: [],
  key: "retry",
  event: "h_click",
  disablePlaceholerMessage: false,
  data: null,
};

export const EXPLORE_MORE_OPTION = {
  content: {
    component: "NormalOptionTile",
    componentOptions: { icon: "", label: "exploreMore", callbackOptions: null },
  },
  nextOptionsType: "Init",
  message: [{ message: "exploreMore", speaker: "user" }],
  key: "exploreMore",
  event: "h_click",
  disablePlaceholerMessage: false,
  data: null,
};

export const SHOW_ALL_UNITS_OPTION = {
  content: {
    component: "NormalOptionTile",
    componentOptions: { icon: "", label: "showAllUnit", callbackOptions: null },
  },
  nextOptionsType: "UnitsAll",
  message: [{ message: "showAllUnit", speaker: "user" }],
  key: "bedrooms",
  event: "h_click",
  disablePlaceholerMessage: false,
  data: null,
};

export const FORM_4_SCHEDULE_TOUR_OPTIONS = [
  {
    content: {
      component: "FullWidthInput",
      componentOptions: {
        placeholder: "firstName",
        type: "text",
        label: "firstName",
        officialLabel: "first name",
        validate: "TEXT_ONLY",
        callbackOptions: null,
      },
    },
    message: [],
    nextOptionsType: "PostScheduleTour",
    key: "first_name",
    isRequired: true,
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
  {
    content: {
      component: "FullWidthInput",
      componentOptions: {
        placeholder: "lastName",
        type: "text",
        label: "lastName",
        officialLabel: "last name",
        validate: "TEXT_ONLY",
        callbackOptions: null,
      },
    },
    message: [],
    nextOptionsType: "PostScheduleTour",
    key: "last_name",
    isRequired: true,
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
  {
    content: {
      component: "FullWidthInput",
      componentOptions: {
        placeholder: "email",
        type: "email",
        label: "email",
        officialLabel: "email",
        validate: "EMAIL",
        callbackOptions: null,
      },
    },
    message: [],
    nextOptionsType: "PostScheduleTour",
    key: "email",
    isRequired: true,
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
  {
    content: {
      component: "FullWidthInput",
      componentOptions: {
        placeholder: "phoneNumber",
        type: "text",
        label: "phoneNumber",
        officialLabel: "phone number",
        validate: "PHONE",
        callbackOptions: null,
        isOptional: true,
      },
    },
    nextOptionsType: "PostScheduleTour",
    message: [],
    key: "phone",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
];

export const FORM_4_CONTACT_US_OPTIONS = [
  {
    content: {
      component: "FullWidthInput",
      componentOptions: {
        placeholder: "firstName",
        type: "text",
        label: "firstName",
        officialLabel: "first name",
        validate: "TEXT_ONLY",
        callbackOptions: null,
      },
    },
    message: [],
    nextOptionsType: "PostContactUs",
    key: "first_name",
    isRequired: true,
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
  {
    content: {
      component: "FullWidthInput",
      componentOptions: {
        placeholder: "lastName",
        type: "text",
        label: "lastName",
        officialLabel: "last name",
        validate: "TEXT_ONLY",
        callbackOptions: null,
      },
    },
    message: [],
    nextOptionsType: "PostContactUs",
    key: "last_name",
    isRequired: true,
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
  {
    content: {
      component: "FullWidthInput",
      componentOptions: {
        placeholder: "email",
        type: "email",
        label: "email",
        officialLabel: "email",
        validate: "EMAIL",
        callbackOptions: null,
      },
    },
    message: [],
    nextOptionsType: "PostContactUs",
    key: "email",
    isRequired: true,
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
  {
    content: {
      component: "FullWidthInput",
      componentOptions: {
        placeholder: "phoneNumber",
        type: "text",
        label: "phoneNumber",
        officialLabel: "phone number",
        validate: "PHONE",
        callbackOptions: null,
        isOptional: true,
      },
    },
    nextOptionsType: "PostContactUs",
    message: [],
    key: "phone",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
];

export const FAQS_OPTIONS = [
  {
    content: {
      component: "FullWidthInput",
      componentOptions: {
        placeholder: "Enter your question here...",
        type: "text",
        label: "AMA",
        officialLabel: "AMA",
        validate: null,
        callbackOptions: null,
      },
    },
    message: [],
    nextOptionsType: null,
    key: "faqs",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
];

export const WHEN_MOVE_IN_OPTIONS = [
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: null, label: "asap", callbackOptions: null },
    },
    nextOptionsType: "Units",
    message: [{ message: "asap", speaker: "user" }],
    key: "movein date",
    event: "h_click",
    disablePlaceholerMessage: true,
    data: null,
  },
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: null, label: "next30Days", callbackOptions: null },
    },
    nextOptionsType: "Units",
    message: [{ message: "next30Days", speaker: "user" }],
    key: "movein date",
    event: "h_click",
    disablePlaceholerMessage: true,
    data: null,
  },
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: null, label: "next60Days", callbackOptions: null },
    },
    nextOptionsType: "Units",
    message: [{ message: "next60Days", speaker: "user" }],
    key: "movein date",
    event: "h_click",
    disablePlaceholerMessage: true,
    data: null,
  },
  {
    content: {
      component: "DatePickerOptionTile",
      componentOptions: {
        disablePreviousDates: true,
        callbackOptions: null,
      },
    },
    message: [],
    nextOptionsType: "Units",
    key: "movein date",
    event: "h_click",
    disablePlaceholerMessage: true,
    data: null,
  },
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: null, label: "notSure", callbackOptions: null },
    },
    nextOptionsType: "Units",
    message: [{ message: "notSure", speaker: "user" }],
    key: "movein date",
    event: "h_click",
    disablePlaceholerMessage: true,
    data: null,
  },
];

export const VISIT_RESIDENT_PORTAL_OPTIONS = [
  {
    content: {
      component: "LinkOptionTile",
      componentOptions: {
        icon: "OpenLinkIcon",
        label: "takeResidentalPortal",
        link: "",
      },
    },
    message: [],
    nextOptionsType: null,
    key: "go_to_resident_portal",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: null, label: "exploreMore", callbackOptions: null },
    },
    nextOptionsType: "Initx",
    message: [{ message: "exploreMore", speaker: "user" }],
    key: "exploreMore",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
];

export const SELF_TOUR_OPTIONS = [
  {
    content: {
      component: "LinkOptionTile",
      componentOptions: {
        icon: null,
        label: "proceedSelfGuideTour",
        link: "",
      },
    },
    message: [],
    nextOptionsType: null,
    key: "proceed_self_tour",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: null, label: "goBack", callbackOptions: null },
    },
    nextOptionsType: "ScheduleTour",
    message: [{ message: "goBack", speaker: "user" }],
    key: "go_back",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
];

export const DO_I_QUALIFY_OPTIONS = [
  {
    content: {
      component: "FullWidthInput",
      componentOptions: {
        placeholder: "Enter the amount here...",
        type: "number",
        label: "doIQualify",
        officialLabel: "doIQualify",
        validate: null,
        callbackOptions: null,
      },
    },
    message: [],
    nextOptionsType: "Init",
    key: "do_i_qualify",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
];

export const INITIAL_REPLIES = {
  checkStorage: false,
  disableResetBox: true,
  options: INITIAL_REPLY_OPTIONS,
  optionsType: "Init",
  title: "",
  renderType: "boxView",
  optionLabel: "",
  // optionLabel: "selectToContinue",
};

export const CANCEL_TOUR_REPLIES = {
  checkStorage: false,
  disableResetBox: true,
  options: CANCEL_TOUR_OPTIONS,
  optionsType: "",
  title: "",
  renderType: "boxView",
  optionLabel: "",
  // optionLabel: "selectToContinue",
};

export const LANG_CHANGE_REPLIES = {
  checkStorage: false,
  disableResetBox: true,
  options: LANG_CHANGE_OPTIONS,
  optionsType: "",
  title: "",
  renderType: "boxView",
  optionLabel: "",
};

export const RESCHEDULE_TOUR_REPLIES = {
  checkStorage: false,
  disableResetBox: true,
  options: RESCHEDULE_TOUR_OPTIONS,
  optionsType: "",
  title: "",
  renderType: "boxView",
  optionLabel: "",
  // optionLabel: "selectToContinue",
};

export const POST_CONTACT_US_REPLIES = {
  checkStorage: false,
  disableResetBox: true,
  options: filter(INITIAL_REPLY_OPTIONS, (o) => !["contact_us"].includes(o.key)),
  optionsType: "Init",
  title: "",
  renderType: "boxView",
};

export const POST_SCHEDULE_TOUR_REPLIES = {
  checkStorage: false,
  disableResetBox: true,
  options: filter(INITIAL_REPLY_OPTIONS, (o) => !["schedule_tour"].includes(o.key)),
  optionsType: "Init",
  title: "",
  renderType: "boxView",
};

export const RETRY_OPTION_REPLIES = {
  checkStorage: false,
  disableResetBox: false,
  options: [RETRY_OPTION, EXPLORE_MORE_OPTION],
  optionsType: "Init",
  title: "",
  renderType: "boxView",
};

export const FEEDBACK_TOUR_REPLIES = {
  checkStorage: false,
  disableResetBox: false,
  options: FEEDBACK_TOUR_OPTIONS,
  optionsType: "Feedback",
  title: "",
  renderType: "boxView",
};

export const FEEDBACK_CONTACT_REPLIES = {
  checkStorage: false,
  disableResetBox: false,
  options: FEEDBACK_CONTACT_OPTIONS,
  optionsType: "Feedback",
  title: "",
  renderType: "boxView",
};

export const FORM_4_SCHEDULE_TOUR_REPLIES = {
  checkStorage: true,
  disableResetBox: false,
  options: FORM_4_SCHEDULE_TOUR_OPTIONS,
  optionsType: "Form4ScheduleTour",
  title: "Enter First Name, Last Name, Email, and Phone Number (optional)",
  renderType: "multiInputView",
};

export const FORM_4_CONTACT_US_REPLIES = {
  checkStorage: true,
  disableResetBox: false,
  options: FORM_4_CONTACT_US_OPTIONS,
  optionsType: "Form4ContactUs",
  title: "Enter First Name and Last Name",
  renderType: "multiInputView",
};

export const FAQS_REPLIES = {
  checkStorage: false,
  disableResetBox: false,
  options: FAQS_OPTIONS,
  optionsType: "FAQs",
  title: "What would you like to know about this property?",
  renderType: "inputView",
};

export const WHEN_MOVE_IN_REPLIES = {
  checkStorage: false,
  disableResetBox: false,
  options: WHEN_MOVE_IN_OPTIONS,
  optionsType: "WhenMoveIn",
  title: "",
  renderType: "boxView",
};

export const VISIT_RESIDENT_PORTAL_REPLIES = {
  checkStorage: false,
  disableResetBox: true,
  options: VISIT_RESIDENT_PORTAL_OPTIONS,
  optionsType: "VisitResidentPortal",
  title: "",
  renderType: "boxView",
};

export const SELF_TOUR_REPLIES = {
  checkStorage: false,
  disableResetBox: true,
  options: SELF_TOUR_OPTIONS,
  optionsType: "SelfTour",
  title: "",
  renderType: "boxView",
};
export const DO_I_QUALIFY_REPLIES = {
  checkStorage: false,
  disableResetBox: true,
  options: DO_I_QUALIFY_OPTIONS,
  optionsType: "DoIQualify",
  title: "",
  renderType: "inputView",
};

export const wrapLines = (str, maxLen) => {
  let reg = new RegExp("(?=\\S).{0," + (maxLen - 1) + "}\\S(?!\\S)|\\S{" + maxLen + "}", "gm");

  return Array.from(str.matchAll(reg), (m) => m[0]);
};

export const initialKeyOptions = {
  BedroomTypes: "find a home",
  PostScheduleTour: "scheduled tour",
  ScheduleTour: "schedule a tour",
  Form4ScheduleTour: "schedule a tour",
  Photos: "photos",
  Videos: "videos",
  CommunityInfo: "community info",
  PostContactUs: "guest card",
  Form4ContactUs: "contact us",
  VisitResidentPortal: "resident portal",
  FAQs: "faqs",
};

export const feedbackKeyOptions = {
  LikeTour: "schedule_a_tour",
  DisLikeTour: "schedule_a_tour",
  SkipTour: "schedule_a_tour",
  LikeContact: "contact_us",
  DisLikeContact: "contact_us",
  SkipContact: "contact_us",
};

export const dotLoader = `<span style="animation-delay: 300ms;" class="bounce-dot hayley-inline-block hayley-w-1 hayley-h-1 hayley-rounded-full hayley-bg-black"></span>
  <span style="animation-delay: 600ms;" class="bounce-dot hayley-inline-block hayley-w-1 hayley-h-1 hayley-rounded-full hayley-bg-black"></span>
  <span style="animation-delay: 900ms;" class="bounce-dot hayley-inline-block hayley-w-1 hayley-h-1 hayley-rounded-full hayley-bg-black"></span>
  `;

export const optionTypes = {
  PostScheduleTour: `confirmingTour`,
  PostContactUs: `submitContactForm`,
  Photos: `loadingPhotos`,
  Videos: `loadingVideos`,
  CommunityInfo: `loadingCommunityInfo`,
  VisitResidentPortal: `loadingOptions`,
  UnitsAll: `loadingAllUnit`,
};

export const loaders = [
  `confirmingTour`,
  `submitContactForm`,
  `loadingPhotos`,
  `loadingVideos`,
  `loadingCommunityInfo`,
  `loadingOptions`,
  `loadingAllUnit`,
  "loadingUnits",
  "typing",
  "loading",
];

export const hotKeysOptions = {
  find_home: "find a home",
  schedule_tour: "schedule a tour",
  photos: "photos",
  videos: "videos",
  community_info: "community info",
  contact_us: "contact us",
  visit_resident_portal: "resident portal",
};

export const translation = (id, value) => {
  const lang = t(id) === id ? value : t(id);

  return lang;
};

export const UNIT_TYPE_LABELS = {
  studio: "Studio",
  "0-bedroom": "0 Bed",
  "1-bedroom": "1 Bed",
  "2-bedrooms": "2 Bed",
  "3-bedrooms": "3 Bed",
  "4-bedrooms": "4 Bed",
};

export const detectAndGenerateLinks = (text) => {
  // Regular expressions for detecting email, phone, and URL
  const emailRegex = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/g;
  const phoneRegex = /(?:\(\d{3}\)|\d{3})[-.\s]? *\d{3}[-.\s]?\d{4}\b/g;
  const urlRegex = /(https?:\/\/[^\s]+)/g;

  // Replace email addresses with HTML mailto links
  const textWithEmailLinks = text?.replace(
    emailRegex,
    '<a href="mailto:$&" class="hayley-font-semibold hayley-cursor-pointer hayley-underline hayley-text-[#4f6fae] hover:hayley-text-primary">$&</a>'
  );

  // Replace phone numbers with HTML tel links
  const textWithPhoneLinks = textWithEmailLinks?.replace(
    phoneRegex,
    '<a href="tel:$&" class="hayley-font-semibold hayley-cursor-pointer hayley-underline hayley-text-[#4f6fae] hover:hayley-text-primary">$&</a>'
  );

  // Replace URLs with HTML links
  const textWithUrlLinks = textWithPhoneLinks?.replace(
    urlRegex,
    '<a href="$&" target="_blank" class="hayley-font-semibold hayley-cursor-pointer hayley-underline hayley-text-[#4f6fae] hover:hayley-text-primary">$&</a>'
  );

  return textWithUrlLinks;
};

export const getWidgetRefHeight = (position, hotkeysRef, mascotHeight) => {
  if (position === "sticky-right") {
    return "120px";
  }

  const hotKeysHeight = `${(hotkeysRef?.scrollHeight || 0) + mascotHeight}px`;

  return hotKeysHeight;
};

export const getWidgetHeight = (settings, messages, position, promotionOffer, mascotHeight) => {
  if (position === "sticky-right") {
    return `120px`;
  }

  // Tooltip space above close icon to prevent overlap
  const TOOLTIP_SPACE = 40;

  if (messages?.length > 2) {
    return `${20 + 20 + mascotHeight}px`;
  }

  if (settings?.bubbleType == "offers") {
    const length = wrapLines(promotionOffer?.description || "", 35)?.length || 0;

    const endDateTextHeight = promotionOffer?.dynamic_end_date_text ? 20 : 0;

    const calculateHeight = 20 * (length + 1);
    // tooltipSpace + padding + closeIcon + widgetIcon
    const totalHeight = TOOLTIP_SPACE + 28 + 28 + mascotHeight + calculateHeight + endDateTextHeight;

    return `${length ? totalHeight : mascotHeight}px`;
  }

  if (settings?.bubbleType == "quick_actions") {
    const length = settings?.quickActions?.length || 0;

    const calculateHeight = 20 * length;
    // tooltipSpace + padding + closeIcon + widgetIcon
    const totalHeight = TOOLTIP_SPACE + 28 + 28 + mascotHeight + calculateHeight;

    return `${length ? totalHeight : mascotHeight}px`;
  }

  if (settings?.bubbleType == "welcome_message") {
    const length = wrapLines(settings?.welcomeMessage, 35)?.length || 0;

    const calculateHeight = 20 * length;
    // tooltipSpace + padding + closeIcon + widgetIcon
    const totalHeight = TOOLTIP_SPACE + 28 + 28 + mascotHeight + calculateHeight;

    return `${length ? totalHeight : mascotHeight}px`;
  }

  return `${mascotHeight}px`;
};

export const numberCommaFormat = (number) => {
  if (typeof number !== "number") {
    return number;
  }

  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const filterFaqOptions = (obj) => {
  const {
    showFaq,
    photos,
    videos,
    community_info,
    visit_resident_portal,
    find_a_home,
    // schedule_a_tour,
    in_person_tour,
    live_video_tour,
    self_guided_tour,
  } = store.getState().property;

  const filteredOptions = filter(obj.options, (o) => {
    if (o.key === "find_home" && !find_a_home) {
      return false;
    }

    if (o.key === "visit_resident_portal" && !visit_resident_portal) {
      return false;
    }

    if (o.key === "photos" && !photos) {
      return false;
    }

    if (o.key === "videos" && !videos) {
      return false;
    }

    if (o.key === "community_info" && !community_info) {
      return false;
    }

    if (o.key === "schedule_tour" && !(in_person_tour || live_video_tour || self_guided_tour)) {
      return false;
    }

    if (o.key === "faqs" && !showFaq) {
      return false;
    }

    return true;
  });

  const data = {
    ...obj,
    options: filteredOptions,
  };

  return data;
};

export const compMsgKeys = {
  unitView: "find_home",
  galleryView: "photos",
  videosGalleryView: "videos",
  featuresView: "community_info",
};

export const defaultEditFormats = [
  // "PostContactUs",
  // "PostScheduleTour",
  "BedroomTypes",
  "ScheduleTour",
  "Photos",
  "Videos",
  "Form4ContactUs",
  "VisitResidentPortal",
  "CommunityInfo",
  "FAQs",
];

export const reportIds = ["1528252253585581240"];

function toCamelCase(str) {
  return str
    .split(" ")
    .map((word, index) => {
      if (index === 0) {
        return word.toLowerCase();
      }

      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join("")
    .replace(/[^a-zA-Z0-9]/g, "");
}

export function filterRepliesByOptions(originalReplies, optionsFromAPI) {
  const optionsFromAPILowercase = optionsFromAPI?.map((option) => option?.toLowerCase());
  const optionsFromAPICamelCase = optionsFromAPI?.map((option) => toCamelCase(option));

  const filteredOptions = originalReplies.options.filter((option) => {
    const optionLabelLowercase = option.content.componentOptions.label;

    return (
      optionsFromAPICamelCase.includes(optionLabelLowercase) ||
      optionsFromAPILowercase.includes(optionLabelLowercase) ||
      optionLabelLowercase === "notSure" ||
      option.content.component === "DatePickerOptionTile"
    );
  });

  return {
    ...originalReplies,
    options: filteredOptions,
  };
}

export const optionsBySubject = {
  photos: "Photos",
  "schedule a tour": "ScheduleTour",
  "unit availability": "BedroomTypes",
  "resident portal": "VisitResidentPortal",
  videos: "Videos",
  embed_map_view: "EmbedMapView",
  esp_not_enabled: "EspNotEnabled",
};

export const EVENT_TAGS = {
  find_home: "FAA_CLICKED",
  "price range": "FAA_CLICKED",
  "movein date": "FAA_CLICKED",
  schedule_tour: "SAT_CLICKED",
  bedrooms: "FAA_CLICKED",
  contact_us: "CONTACT_ME_CLICKED",
  photos: "PHOTOS_CLICKED",
  videos: "VIDEOS_CLICKED",
  community_info: "COMMUNITY_INFO_CLICKED",
  visit_resident_portal: "RESIDENT_PORTAL_CLICKED",
  do_i_qualify: "DO_I_QUALIFY_CLICKED",
  custom_btn: "CUSTOM_BUTTON_CLICKED",
};
export const EVENT_Keys = {
  find_home: "find a home",
  "price range": "price range",
  "movein date": "move in date",
  schedule_tour: "schedule a tour",
  bedrooms: "bedrooms",
  contact_us: "contact me",
  photos: "photos",
  videos: "videos",
  community_info: "community info",
  visit_resident_portal: "resident portal",
  do_i_qualify: "do i qualify",
  custom_btn: "custom button",
};

export const FOLLOW_UP_KEYS = [
  "negative feedback",
  "negative sentiment",
  "unsatisfactory answer",
  "off topic questions",
  "complaint filing",
  "seeking clarification",
  "prompt injection",
  "family friendly_housing",
  "gender inclusiveness",
  "community security",
  "cultural inclusivity",
  "accessibility features",
  "seeking help",
];

export const TOUR_MSGS_KEY = {
  cancelTour: "yesCancel",
  noDoNotCancel: "dontCancel",
};

export const SCHEDULE_TOUR_INQUIRIES = ["schedule_inquiry", "cancel_inquiry", "reschedule_inquiry", "status_inquiry"];

export const HAYLEY_EXTRA_OPTION_SOURCES = ["videos", "showUnits", "photos", "unitView", "community_info", "inputView", "neighborhood_summary", "embed_map"];

export const HAYLEY_MESSAGE_EDIT_TYPES = ["ScheduleTour", "BedroomTypes", "Form4ScheduleTour"];

export const CANCEL_FORM_KEYS = {
  schedule_tour: "Schedule a tour",
  contact_me: "Contact me",
};

export const APPOINTMENT_TYPES = {
  "In-Person Tour": "in_person_tour",
  "Live Video Tour": "live_video_tour",
  "Self Guided Tour": "self_guided_tour",
};

export const DUMMY_DISCLAIMER = `<p>By interacting with this system, you consent to the <strong><u>privacy policy</u></strong>, including being contacted by AI or a human & having your conversation recorded by a third party.</p>`;

export const chatData = {
  response: {
    description: "Unfortunately, no apartments are available that match your preference.",
    available_slots: {
      search_result: false,
      tour_link: "",
      case: "1",
      ignored_filter_fields: [],
      flexible_move_in_date: false,
      floor_plans: [],
    },
  },
  message_id: "TWVzc2FnZS0xODM5NjI0NTQzMDg4NDg4NDcy",
  subject: "unit availability",
  available_tourTypes: [],
  not_available: [],
  context: [
    {
      preferredTime: "08:30",
      preferredDate: "2025-08-05",
      tourType: "in_person_tour",
      tourAction: "schedule_confirmation",
      subject: "schedule_a_tour",
      entryId: "1826294264267695621",
      email: "aliraza123@gmail.com",
      firstName: "ali",
      lastName: "raza",
      source: "chat",
      phoneNumber: "",
      bookingId: "",
      newPreferredDate: "",
      newPreferredTime: "",
      apiClass: "confirmation",
      buffer: "",
      booking_found: false,
      required_info: false,
      error_code: 500,
    },
  ],
  neighborhood_summary: "",
  follow_up: "",
  latency: {
    retreive_preference_context: {
      response_time_cache_hit: 0.002294778823852539,
    },
    agent_orchestrator_microservice: {
      orchestrator_latency: {
        orchestrator_llm_latency: 3.5022,
        tool_latency: 1.59,
        backend_api_latency: 1.5906171798706055,
      },
    },
    network_latency: 0.08650000000000005,
    translate_to_human_latency: 0,
    hayley_engine_latency: 5.19,
    chat_adapter_latency: 5.58,
  },
  images_url: "",
  preference_context: {
    entryId: "1826294264267695621",
    desiredBedrooms: 0,
    desiredPriceLow: 2500,
    desiredPriceHigh: 5000,
    desiredMoveIn: "2025-07-01 00:00:00 UTC",
    touredAt: "2025-07-27T12:00:00Z",
    scheduledAt: "",
    meta: '{"date_type":"before"}',
  },
  language: "en",
  agent_handoff: {
    handoff_reason: "no_handoff",
    agent_handoff_triggered: false,
    need_info: "",
  },
};
